<template>
  <tbody>
    <tr>
      <td class="center-tablet">{{ item?.clientName }}</td>
      <td class="hide-tablet hide-movil center-tablet">
        {{ item.clients?.telephones[0] || "No disponible" }}
      </td>
      <td class="hide-movil center-tablet">{{ formatDate }}</td>
      <td class="hide-tablet hide-movil center-tablet">{{ formatHour}}</td>
      <td class="hide-tablet hide-movil center-tablet" :class="getStatus">
        {{ getStatus }}
      </td>
      <td class="center-tablet">
        <div class="actions-container">
          <Dropdown :disabled="getDisabled" :placeholder="getStatus" @status="handleStatus" :items="options" />
          <button @click="handleEditar(item)" class="btn-edit"></button>
        </div>
      </td>
      <td class="hide-web">
        <div @click="handleActiveTable" class="arrow-container center-tablet">
          <img src="../../../assets/imgs/icons/Dropdown.svg" />
        </div>
      </td>
    </tr>
    <template v-if="active">
      <tr :class="active ? 'active' : ''" class="table-dropdown-container">
        <td class="center-tablet">
          <div class="item-t-dropdown">
            <span>Teléfono</span>
            <span>{{ item.clients?.telephones[0] || "No disponible" }}</span>
          </div>
          <div class="item-t-dropdown hide-tablet">
            <span>Hora</span>
            <span>{{ formatHour }}</span>
          </div>
        </td>
        <td class="center-tablet">
          <div class="item-t-dropdown hide-tablet">
            <span>Fecha</span>
            <span>{{ formatDate }}</span>
          </div>

          <div class="item-t-dropdown hide-tablet">
            <span>Estatus de la cita</span>
            <span :class="getStatus">{{ getStatus }}</span>
          </div>

          <div class="item-t-dropdown hide-movil">
            <span>Hora</span>
            <span>{{ item.hour }}</span>
          </div>
        </td>

        <td class="hide-movil center-tablet table-cell">
          <div class="item-t-dropdown">
            <span>Estatus de la cita</span>
            <span :class="getStatus">{{ getStatus }}</span>
          </div>
        </td>
      </tr>
    </template>
  </tbody>
</template>

<script>
import Dropdown from "../../Dropdowns/Dropdown.vue";
import moment from "moment";
export default {
  components: {
    Dropdown,
  },
  props: {
    item: {
      type: Object,
      require: true,
      default: () => {},
    },
  },
  emits:["status","editarCita"],
  data() {
    return {
      active: false,
      options: [
        { value: 0, text: "Cancelar" },
        { value: 1, text: "Pendiente" },
        { value: 2, text: "No asistio" },
        { value: 3, text: "Asistio" },
      ],
    };
  },
  methods: {
    handleActiveTable() {
      this.active = !this.active;
    },
    handleStatus(status){
      this.$emit("status",{status,cliente:this.item?.clientName,id:this.item?._id})
    },
    handleEditar(item){
      this.$emit("editarCita",item)
    }
  },
  computed: {
    getStatus() {
      switch (this.item.status) {
        case "0":
          return "Cancelar";
        case "1":
          return "Pendiente";
        case "2":
          return "No asistio";
        case "3":
          return "Asistio";
        default:
          return "Pendiente";
      }
    },
    getDisabled(){
      return this.item.status == 1 ? false : true
    },
 
  formatDate(){
    return moment(this.item.date).format("DD-MM-YYYY")
  },
  formatHour(){
    if(this.item?.hour > 12) return `${this.item?.hour - 12}`.padStart(2,"00")+":00 PM"
    return `${this.item?.hour}`.padStart(2,"00")+":00 AM"
  }
},
};
</script>

<style scoped>
.center {
  text-align: center;
}

.items-container {
  display: flex;
  flex-direction: column;
}
.btn-edit {
  width: 20px;
  height: 20px;
  background-image: url("../../../assets/imgs/icons/icon-edit.svg");
}

.table-dropdown-container {
  height: 0;
  max-height: 0;
  opacity: 0;
  transition: height 0.35s ease-out, opacity 0.1s ease;
}

.item-t-dropdown {
  display: flex;
  align-items: center;
  flex-direction: column;
}

.t-items-container {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
}

.table-dropdown-container.active {
  max-height: min-content;
  height: 100px;
  min-width: 100%;
  opacity: 1;
}

.Cancelar {
  color: #ff3737 !important;
}
.Pendiente {
  color: #0a4f9c !important;
}
.Asistio {
  color: #2196f3 !important;
}
.No {
  color: #fb8c00 !important;
}
.table-container {
  min-height: 562.5px;
  background-color: #fff;
}

.arrow-container {
  width: 100%;
  max-width: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.arrow {
  max-width: 50px;
}
.actions-container {
  display: grid;
  grid-template-columns: min-content min-content;
  column-gap: 10px;
  align-items: center;
}

.empty-container {
  min-height: 500px;
  width: 100%;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.message-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
}

.icon-message {
  width: 100px;
  height: 100px;
}

.message {
  text-align: center;
  font: normal normal 600 20px/23px Open Sans;
  letter-spacing: 0px;
  color: #0a4f9c;
}

table {
  background-color: #fff;
  text-align: left;
  border-collapse: collapse;
  width: 100%;
}

th {
  padding: 20px 20px;
  font: normal normal bold 16px/22px Open Sans;
  color: #616161;
}

td {
  padding: 15px 20px;
  font: normal normal normal 14px/19px Open Sans;
  color: #616161;
}

thead {
  background: #f3f3f3 0% 0% no-repeat padding-box;
  border-radius: 4px 4px 0px 0px;
}
tr:first-child {
  border-top: none;
}
tr {
  border: 1px solid #e5e5e5;
}
/* tbody tr {
  cursor: pointer;
} */
tbody tr:hover {
  background: #f3f3f3 0% 0% no-repeat padding-box;
}

.hide-web {
  display: none;
}

/* TABLET */
@media screen and (max-width: 1279px) {
  .center-tablet {
    text-align: center;
    justify-content: center;
    align-items: center;
  }
  .hide-web {
    display: table-cell;
  }

  .hide-movil {
    display: flex;
  }

  .table-cell {
    display: table-cell !important;
  }

  .hide-tablet {
    display: none;
  }

  .actions-container {
    justify-content: center;
  }
}

/* MOVIL */
@media screen and (max-width: 767px) {
  /* .table-container{
      min-height: 342.5px;
  }
  
  .empty-container{
    min-height: 300px;
  }  */

  .table-cell {
    display: none !important;
  }

  .hide-tablet {
    display: flex;
  }

  .hide-web {
    display: table-cell;
  }

  .hide-movil {
    display: none;
  }

  th {
    padding: 20px 5px;
    font: normal normal bold 11px/22px Open Sans;
  }

  td {
    padding: 15px 5px;
    font: normal normal normal 10px/19px Open Sans;
  }
}
</style>
